var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-multipane",class:{
        'l-multipane--vertical': _vm.type === 'vertical',
        'l-multipane--horizontal': _vm.type === 'horizontal'
    }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }